import React from 'react';
import { Form } from 'react-bootstrap';
import { Control, FieldErrors, UseFormRegister, UseFormWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';

import { useAppDispatch } from '../../app/hook';
import PopoverWithAudio, { IPopoverWithAudioType } from '../../components/common/PopoverWithAudio';
import ProBadge from '../../components/ui/ProBadge';
import usePermission from '../../hooks/usePermission';
import { handleResetAppearance, handleUpdateAppearanceItem } from './appearanceSlice';
import { IAiAppearance } from './types';

type Props = {
  register: UseFormRegister<IAiAppearance>;
  watch: UseFormWatch<IAiAppearance>;
  errors: FieldErrors<IAiAppearance>;
  control: Control<IAiAppearance, any>;
};

function AppearanceEnableSeo({ register, watch, errors, control }: Props) {
  const permissions = usePermission();
  const { i18n, t } = useTranslation();
  const dispatch = useAppDispatch();

  const voiceResponsePopData: IPopoverWithAudioType = {
    contentText: t('DashboardSettingCustomizeChat/pop-16'),
  };

  return (
    <React.Fragment>
      <div className={'tw-self-stretch tw-flex-col tw-justify-start tw-items-start tw-gap-3 tw-flex'}>
        <div className="tw-self-stretch tw-justify-start tw-items-start tw-gap-6 tw-flex tw-w-full tw-flex-col">
          <Form.Group className="tw-flex tw-items-center tw-gap-2 tw-mb-4">
            <Form.Check
              disabled={!permissions.settingsPage.widget.customization.notificationBadge}
              type="switch"
              id="enableSeo"
              className="tw-flex tw-items-center tw-gap-2 tw-text-gray-700 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight"
              label={t('DashboardSettingCustomizeChat/enableSeo')}
              {...register('enableSeo', {
                onChange: (e: any) => {
                  dispatch(
                    handleUpdateAppearanceItem({
                      key: 'enableSeo',
                      value: e.target.checked,
                    })
                  );
                },
              })}
            />
            {!permissions.settingsPage.widget.customization.notificationBadge && (
              <ProBadge
                className="tw-ms-2"
                onClose={() => {
                  dispatch(handleResetAppearance());
                }}
              />
            )}
            <PopoverWithAudio
              data={{
                contentText: voiceResponsePopData.contentText,
              }}
            />
          </Form.Group>
        </div>
      </div>
    </React.Fragment>
  );
}

export default WrappedErrorBoundary(AppearanceEnableSeo);
